import { render, staticRenderFns } from "./ContentGen.vue?vue&type=template&id=f77b2ca8&scoped=true"
import script from "./ContentGen.vue?vue&type=script&lang=js"
export * from "./ContentGen.vue?vue&type=script&lang=js"
import style0 from "./ContentGen.vue?vue&type=style&index=0&id=f77b2ca8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f77b2ca8",
  null
  
)

export default component.exports